<template>
	<div>
		<van-popup
			style="border-radius: 4px; width: 90%; padding: 20px"
			closeable
			round
			v-model:show="showModal"
			:close-on-click-overlay="false"
		>
			<div class="pay">
				<div>請輸入對應信息</div>
				<div style="display: flex; align-items: center; margin-top: 25px">
					<div>CNY</div>
					<div style="margin-left: 35px">
						<el-input type="number" v-model="input" placeholder="请输入支付金额" />
					</div>
				</div>
				<div class="addcode" @click="buildCode" style="background-color: #169bd5">生成二维码</div>
			</div>
		</van-popup>
		<van-popup
			v-model:show="showMa"
			closeable
			round
			style="border-radius: 4px; width: 80%; padding: 20px"
			:close-on-click-overlay="false"
			@click-close-icon="onClickCloseIcon()"
		>
			<div style="font-size: 18px; font-weight: 500; color: #303133; margin-top: -5px">提示</div>
			<div class="center_flex_layout" style="margin-top: 30px">
				<div id="qrcode" ref="qrcode"></div>
			</div>
			<div style="width: 268px; margin-top: 17px">
				<div style="color: #303133; font-weight: 400">請向用戶出示二維碼收款</div>
				<div style="color: #f56c6c">注意在用戶支付後才可關閉彈窗，否則會影響支付結果</div>
			</div>
			<div style="display: flex; justify-content: flex-end; margin-top: 37px">
				<el-button @click="quxiao">取消</el-button>
				<el-button type="primary" @click="quxiao"> 確定 </el-button>
			</div>
		</van-popup>
	</div>
</template>

<script setup>
import { reactive, onMounted, getCurrentInstance, ref, onBeforeUnmount, defineExpose } from "vue";
import { Encrypt } from "../../utils/secret";
import { useRouter } from "vue-router";
import { get, post } from "../../utils/request";
import QRCode from "qrcodejs2";
let checkPayTime;
const router = useRouter();
const { proxy } = getCurrentInstance();
const showModal = ref(false);
const input = ref("");
const showMa = ref(false);
const clearPayTime = () => {
	checkPayTime && clearInterval(checkPayTime);
};
const onClickCloseIcon = () => {
	const quires = document.getElementById("qrcode");
	clearPayTime();
	setTimeout(() => {
		quires.innerHTML = "";
	}, 200);
};
const quxiao = () => {
	const quire = document.getElementById("qrcode");
	showMa.value = false;
	clearPayTime();
	setTimeout(() => {
		quire.innerHTML = "";
	}, 200);
};
const getshow = () => {
	showModal.value = true;
	input.value = "";
};
// 生成二维码
const buildCode = () => {
	if (!input.value) {
		proxy.$toast("請輸入金額");
		return;
	}
	showModal.value = false;
	const price = ref({
		price: input.value,
	});

	post(`/manager/order/create`, price.value, null)
		.then((res) => {
			if (res.code == 1) {
				// console.log(res);
				showMa.value = true;
				setTimeout(() => {
					new QRCode("qrcode", {
						width: 200,
						height: 200,
						text: `https://api.sancttech.com/?state=${res.result.id}`,
					});
				}, 50);

				checkPayTime = setInterval(() => {
					checkPayState(res.result.id);
				}, 2000);
			}
		})
		.catch((error) => {
			console.log(error);
		});
};
// 支付查询
const checkPayState = (orderId) => {
	get("/manager/pay/query/" + orderId, {}, false, false)
		.then((res) => {
			if (res.code == 1) {
				// console.log(JSON.stringify(res))
				if (res.result.payState === 2) {
					clearPayTime();
					let passOrderId = encodeURIComponent(Encrypt(JSON.stringify(orderId)));
					router.push("/orderDetail?orderNum=" + passOrderId);
				}
			}
		})
		.catch((error) => {
			console.log(error);
		});
};
onBeforeUnmount(() => {
	console.log(11);
	clearPayTime();
});
defineExpose({ getshow });
</script>

<style lang="less" scoped>
.addcode {
	width: 90px;
	height: 30px;
	border-radius: 3px;
	background-color: #a4adb3;
	text-align: center;
	line-height: 30px;
	color: white;
	margin: 50px auto 0;
}
</style>
